import axios from 'axios'
import app from '../app'
import i18n from '@/config/i18n'

axios.interceptors.request.use(config => {
    config.headers['X-CSRF-TOKEN'] = document.head.querySelector(
        "meta[name='csrf-token']"
    )
    config.headers['X-Requested-With'] = 'XMLHttpRequest'
    config.headers['Locale'] = i18n.locale
    app.$Progress.start()
    return config
}, (error) => {
    app.$Progress.finish()
    return Promise.reject(error)
})
  
axios.interceptors.response.use((response) => {
    app.$Progress.finish()
    return response
  }, (error) => {
    app.$Progress.finish()
    return Promise.reject(error)
  })